// src/components/challenge/challenge.component.js
import React, { Component } from "react";
import axios from "axios";
import { Helmet } from "react-helmet";
//import ComingSoonm from "../menu/comingsoonm.component";
import styled, { createGlobalStyle } from "styled-components";
import ReactGA from "react-ga4";

const catOptions = {
  1: {
    name: "Healthy Living",
    icon: "fitness",
    iconLibrary: "ionicons",
    iconColor: "#27AE60",
    bgcolor: "#D4AC0D",
    img: "cats/cat1a.png",
  },
  2: {
    name: "Break Habits",
    icon: "person-circle-outline",
    iconLibrary: "ionicons",
    iconColor: "#E74C3C",
    bgcolor: "#3F888F",
    img: "cats/cat2c.png",
  },
  3: {
    name: "Career Growth",
    icon: "suitcase",
    iconLibrary: "FontAwesome5",
    iconColor: "#2C3E50",
    bgcolor: "#FF847C",
    img: "cats/cat3a.png",
  },
  4: {
    name: "Smart Money",
    icon: "finance",
    iconLibrary: "MaterialCommunityIcons",
    iconColor: "#1ABC9C",
    bgcolor: "#FFA500",
    img: "cats/cat4a.png",
  },
  5: {
    name: "Lifelong Learning",
    icon: "book-education",
    iconLibrary: "MaterialCommunityIcons",
    iconColor: "#F4D03F",
    bgcolor: "#B565A7",
    img: "cats/cat5a.png",
  },
  6: {
    name: "Explore More",
    icon: "travel-explore",
    iconLibrary: "MaterialIcons",
    iconColor: "#2980B9",
    bgcolor: "#FF7F11",
    img: "cats/cat6a.png",
  },
  7: {
    name: "Family Life",
    icon: "heart-circle-outline",
    iconLibrary: "ionicons",
    iconColor: "#EC7063",
    bgcolor: "#967BB6",
    img: "cats/cat7a.png",
  },
  8: {
    name: "Enjoy Life",
    icon: "clipboard-outline",
    iconLibrary: "ionicons",
    iconColor: "#F7DC6F",
    bgcolor: "#9B2335",
    img: "cats/cat8a.png",
  },
  9: {
    name: "Social Impact",
    icon: "social-skillshare",
    iconLibrary: "Foundation",
    iconColor: "#2E86C1",
    bgcolor: "#88B04B",
    img: "cats/cat9a.png",
  },
  10: {
    name: "Inner Peace",
    icon: "hand-peace",
    iconLibrary: "MaterialCommunityIcons",
    iconColor: "#A9DFBF",
    bgcolor: "#6B5B95",
    img: "cats/cat10a.png",
  },
  11: {
    name: "Get Creative",
    icon: "heart-circle-outline",
    iconLibrary: "ionicons",
    iconColor: "#F39C12",
    bgcolor: "#6B5B95",
    img: "cats/cat11a.png",
  },
  12: {
    name: "Learn Language",
    icon: "language",
    iconLibrary: "ionicons",
    iconColor: "#1F618D",
    action: "custom",
    bgcolor: "#f55442",
    img: "cats/cat12a.png",
  },
  13: {
    name: "Mental Wellness",
    icon: "brain",
    iconLibrary: "MaterialCommunityIcons",
    iconColor: "#D35400",
    bgcolor: "#6B5B95",
    img: "cats/cat13a.png",
  },
  14: {
    name: "Stay Focused",
    icon: "center-focus-strong",
    iconLibrary: "MaterialIcons",
    iconColor: "#52BE80",
    bgcolor: "#6B5B95",
    img: "cats/cat14a.png",
  },
  15: {
    name: "Build Discipline",
    icon: "timetable",
    iconLibrary: "MaterialCommunityIcons",
    iconColor: "#8E44AD",
    action: "custom",
    bgcolor: "#f55442",
    img: "cats/cat15a.png",
  },
};

const GlobalStyle = createGlobalStyle`
  body {
    padding: 0;
    margin: 0;
    overflow: hidden;
    align-items: center;
  }
  .p-challenge {
    word-break: break-word;
    overflow-wrap: break-word;
  }
`;

const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  overflow: hidden;
  min-height: 100vh;
  background: linear-gradient(45deg, #1d9bf0, #ff0080, #4c00ff, #ff7b00);
  background-size: 400% 400%;
  animation: gradientRotate 15s ease infinite;

  @keyframes gradientRotate {
    0% {
      background-position: 0% 50%;
    }
    50% {
      background-position: 100% 50%;
    }
    100% {
      background-position: 0% 50%;
    }
  }
`;

const CenteredContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  flex-grow: 1;
  flex-wrap: wrap;
  padding-top: 10px;
  width: 100%;
  max-width: 800px;
`;

const ChallengeCard = styled.div`
  background-color: rgba(0, 0, 0, 0.7);
  border-radius: 10px;
  padding: 20px;
  margin: 20px;
  width: 90%;
  max-width: 600px;
  color: white;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
`;

const ChallengeTitle = styled.h1`
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 15px;
  text-align: center;
`;

const ChallengeDescription = styled.p`
  font-size: 16px;
  line-height: 1.5;
  margin-bottom: 20px;
`;

const JoinButton = styled.button`
  background-color: #007df4;
  color: white;
  border: none;
  border-radius: 10px;
  padding: 10px 16px;
  font-size: 15px;
  font-weight: 500;
  cursor: pointer;
  width: 100%;
  margin-top: 6px;

  &:hover {
    background-color: #0068cc;
  }
`;

class Challenge extends Component {
  constructor(props) {
    super(props);

    // Get challenge ID from URL params
    const challengeId = this.props.match.params.id;

    this.state = {
      challenge: {
        id: challengeId || "default",
        title: "30-Day Fitness Challenge",
        description:
          "Join our 30-day fitness challenge to transform your body and mind. This challenge includes daily workouts, nutrition tips, and community support.",
        imageUrl:
          //"https://www.bealyo.com/images/challenges/fitness-challenge.jpg",
          "https://www.bealyo.com/images/prebealyoshare.png",
        startDate: "2025-01-01",
        endDate: "2025-01-30",
        participants: 1245,
      },
    };
  }

  componentDidMount() {
    const challengeId = this.props.match.params.id;

    console.log("Challenge ID:", challengeId);

    // Track page view
    ReactGA.send({
      hitType: "pageview",
      page: window.location.pathname + window.location.search,
    });

    // Fetch challenge data from API
    axios
      .get(process.env.REACT_APP_API_URL + "goals/" + challengeId)
      .then((response) => {
        const goalData = response.data;
        console.log("Fetched challenge data:", goalData);
        console.log(
          "Image URL:",
          process.env.REACT_APP_IMG_FOLDER + goalData.goal_imageurl
        );

        // Determine image URL with fallback to catOptions
        const imageUrl =
          goalData.goal_imageurl && goalData.goal_imageurl !== ""
            ? process.env.REACT_APP_IMG_FOLDER + goalData.goal_imageurl
            : process.env.REACT_APP_IMG_FOLDER_FILES +
              catOptions[goalData.goal_catid || 1].img;

        // Map API response to challenge state
        this.setState({
          challenge: {
            id: goalData._id,
            title: goalData.goal_title,
            description: goalData.goal_desc,
            imageUrl:
              goalData.goal_imageurl && goalData.goal_imageurl !== ""
                ? process.env.REACT_APP_IMG_FOLDER + goalData.goal_imageurl
                : process.env.REACT_APP_IMG_FOLDER_FILES +
                  catOptions[goalData.goal_catid || 1].img,
            startDate: new Date(goalData.goal_start_date).toLocaleDateString(),
            endDate: new Date(goalData.goal_duedate).toLocaleDateString(),
            participants: goalData.num_users || 0,
            inviteId: goalData.goal_inviteid,
          },
          loading: false,
        });
      })
      .catch((error) => {
        console.error("Error fetching challenge:", error);
        this.setState({
          error: "Failed to load challenge details",
          loading: false,
        });
      });
  }

  handleJoinClick = (chid) => {
    ReactGA.event({
      category: "Challenge",
      action: "Join Challenge Click",
      label: this.state.challenge.title,
    });
    //window.location.href = "/comingsoon";
    window.location.href = "http://www.bealyo.com/challenge/" + chid;
  };

  render() {
    const { challenge } = this.state;
    const shareUrl = `https://www.bealyo.com/challenge/${challenge.id}`;

    const ogTitle = challenge.title || "Join a Bealyo Challenge";
    const ogDescription =
      challenge.description ||
      "Be part of a community-driven challenge on Bealyo. Android Open Testing is live.";

    return (
      <PageContainer>
        <Helmet>
          <title>{challenge.title} | Bealyo</title>
          <meta name="description" content={challenge.description} />

          {/* App Links for Android */}
          <meta property="al:android:package" content="com.bealyo.bealyoapp" />
          <meta
            property="al:android:url"
            content={`bealyo-app://challenge/${challenge.id}`}
          />
          <meta property="al:android:app_name" content="Bealyo" />

          {/* iOS App Links */}
          <meta
            property="al:ios:url"
            content={`bealyo-app://challenge/${challenge.id}`}
          />
          <meta property="al:ios:app_store_id" content="YOUR_APP_STORE_ID" />
          <meta property="al:ios:app_name" content="Bealyo" />

          {/* Open Graph / Facebook */}
          <meta property="og:type" content="website" />
          <meta property="og:url" content={shareUrl} />
          <meta property="og:title" content={ogTitle} />
          <meta property="og:description" content={ogDescription} />
          <meta property="og:image" content={challenge.imageUrl} />

          {/* Twitter */}
          <meta property="twitter:card" content="summary_large_image" />
          <meta property="twitter:url" content={shareUrl} />
          <meta property="twitter:title" content={ogTitle} />
          <meta property="twitter:description" content={ogDescription} />
          <meta property="twitter:image" content={challenge.imageUrl} />
        </Helmet>

        <GlobalStyle />
        <CenteredContainer>
          <ChallengeCard>
            <ChallengeTitle>{challenge.title}</ChallengeTitle>
            <div style={{ margin: "10px 0", textAlign: "center" }}>
              <div style={{ fontWeight: 700, fontSize: "18px" }}>
                Real people building habits together on Bealyo
              </div>
              <div style={{ fontSize: "13px", opacity: 0.85 }}>
                This challenge runs on Bealyo — a community-driven challenge
                app.
              </div>
            </div>
            <div style={{ margin: "15px 0" }}>
              <div
                style={{
                  position: "relative",
                  width: "100%",
                  height: "230px",
                  borderRadius: "10px",
                  overflow: "hidden",
                  boxShadow: "0 10px 30px rgba(0, 0, 0, 0.25)",
                }}
              >
                <img
                  src={challenge.imageUrl}
                  alt={challenge.title}
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                  }}
                />
                <div
                  style={{
                    position: "absolute",
                    left: 0,
                    right: 0,
                    bottom: 0,
                    height: "55%",
                    background:
                      "linear-gradient(180deg, rgba(0,0,0,0) 0%, rgba(0,0,0,0.65) 100%)",
                  }}
                />
                <div
                  style={{
                    position: "absolute",
                    bottom: "12px",
                    left: "14px",
                    color: "#fff",
                    fontWeight: 600,
                    fontSize: "14px",
                  }}
                >
                  Join the movement.
                </div>
              </div>
            </div>
            <ChallengeDescription>{challenge.description}</ChallengeDescription>
            <div
              style={{
                display: "flex",
                gap: "12px",
                fontSize: "13px",
                margin: "10px 0 6px 0",
                flexWrap: "wrap",
                alignItems: "center",
              }}
            >
              {challenge.startDate && (
                <span>🗓 Start: {challenge.startDate}</span>
              )}
              {challenge.endDate && <span>🏁 End: {challenge.endDate}</span>}
              {challenge.participants !== undefined && (
                <span>👥 {challenge.participants} joined</span>
              )}
            </div>
            <div
              style={{
                margin: "8px 0 14px 0",
                fontSize: "13px",
                opacity: 0.92,
              }}
            >
              Join a supportive community on Bealyo
            </div>
            <div
              style={{ display: "flex", flexDirection: "column", gap: "10px" }}
            >
              <span
                style={{
                  alignSelf: "flex-start",
                  background: "#1d9bf0",
                  color: "#fff",
                  borderRadius: "999px",
                  padding: "4px 10px",
                  fontSize: "12px",
                  fontWeight: 500,
                  letterSpacing: "0.1px",
                }}
              >
                Early Access
              </span>
              <JoinButton
                onClick={() =>
                  window.open(
                    "https://play.google.com/store/apps/details?id=com.bealyo.bealyoapp",
                    "_blank"
                  )
                }
                style={{
                  backgroundColor: "#007DF4",
                  marginTop: "2px",
                  padding: "14px 20px",
                  fontSize: "15px",
                  fontWeight: 500,
                }}
              >
                Get Bealyo (Android Open Testing)
              </JoinButton>
              <div style={{ fontSize: "12px", opacity: 0.85 }}>
                Available on Android (Open Testing) · iOS coming later
              </div>
              <button
                onClick={() => this.handleJoinClick(challenge.id)}
                style={{
                  backgroundColor: "transparent",
                  color: "#cde9ff",
                  border: "1px solid #1d9bf0",
                  padding: "10px 18px",
                  borderRadius: "6px",
                  fontSize: "14px",
                  fontWeight: 700,
                  cursor: "pointer",
                  width: "100%",
                }}
              >
                View in App
              </button>
            </div>
          </ChallengeCard>
        </CenteredContainer>
      </PageContainer>
    );
  }
}

export default Challenge;
